import { makeAutoObservable } from 'mobx';
import { Keyframe } from './Keyframe';

class VideoTrack {
  private id: string;

  private keyframes: Keyframe[];

  constructor(id: string, keyframes: Keyframe[]) {
    this.id = id;
    this.keyframes = keyframes;

    makeAutoObservable(this);
  }

  public getId() {
    return this.id;
  }

  public getKeyframes() {
    return this.keyframes;
  }

  public appendKeyframe(keyframe: Keyframe) {
    this.keyframes.push(keyframe);
  }

  public removeKeyframe(keyframeId: Keyframe['id']) {
    this.keyframes = this.keyframes.filter((keyframe) => keyframe.getId() !== keyframeId);
  }

  public updateKeyframe(keyframeId: Keyframe['id'], updatedKeyframe: Keyframe) {
    const index = this.keyframes.findIndex((keyframe) => keyframe.getId() === keyframeId);

    if (index !== -1) {
      this.keyframes[index] = updatedKeyframe;
    }
  }
}

export { VideoTrack };
